<template>
    <transition>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Reports </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Income Statement</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-primary float-right" @click="toggleModal">
                              Add New
                            </button>  -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 ">
                    <div class="card">
                        <div class="card-header">
                            <h3 style="text-align: center;">Income Statement</h3>
                        </div>

                        <div class="card-body">
                            
                            <div class="row mb-3">
                                <div class="form-group col-md-4">
                                    <label for="company_id">Company *</label><br>
                                    <Multiselect 
                                        class="form-control border company_id" 
                                        mode="single"
                                        v-model="search_terms.company_id"
                                        placeholder="Company Select"  
                                        :searchable="true" 
                                        :filter-results="true"
                                        :options="company_options"
                                        :classes="multiclasses"
                                        :close-on-select="true" 
                                        :min-chars="1"
                                        :resolve-on-load="false"
                                        @change="changeCompany"
                                    /> 
                                    <div class="invalid-feedback" v-if="errors.company_id">
                                        {{errors.company_id[0]}}
                                    </div>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="profit_center_id">Profit Center </label><br>
                                    <Multiselect 
                                        class="form-control border profit_center_id" 
                                        mode="single"
                                        v-model="search_terms.profit_center_id"
                                        placeholder="Profit Center Select"  
                                        :searchable="true" 
                                        :filter-results="true"
                                        :options="profit_center_options"
                                        :classes="multiclasses"
                                        :close-on-select="true" 
                                        :min-chars="1"
                                        :resolve-on-load="false"
                                        @change="changeProfitCenter"
                                    /> 
                                    <div class="invalid-feedback" v-if="errors.profit_center_id">
                                        {{errors.profit_center_id[0]}}
                                    </div>
                                </div>
                            
                                <div class="form-group col-md-4">
                                    <label for="cost_center_id">Cost Center </label><br>
                                    <Multiselect 
                                        class="form-control border cost_center_id" 
                                        mode="single"
                                        v-model="search_terms.cost_center_id"
                                        placeholder="Cost Center Select"  
                                        :searchable="true" 
                                        :filter-results="true"
                                        :options="cost_center_options"
                                        :classes="multiclasses"
                                        :close-on-select="true" 
                                        :min-chars="1"
                                        :resolve-on-load="false"
                                    /> 
                                    <div class="invalid-feedback" v-if="errors.cost_center_id">
                                        {{errors.cost_center_id[0]}}
                                    </div>
                                </div>
            
                            </div>
                            <div class="row">  
                                 
                                <div class="col-md-3">
                                    <label for="fiscal_year_id">Fiscal Year *</label><br>
                                    <Multiselect 
                                        class="form-control border fiscal_year_id" 
                                        mode="single"
                                        v-model="search_terms.fiscal_year_id"
                                        placeholder="Select Fiscal Year"  
                                        :searchable="true" 
                                        :filter-results="true"
                                        :options="fiscal_year_options"
                                        :classes="multiclasses"
                                        :close-on-select="true" 
                                        :min-chars="1"
                                        :resolve-on-load="false"
                                    /> 
                                    <div class="invalid-feedback" v-if="errors.fiscal_year_id">
                                        {{errors.fiscal_year_id[0]}}
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="from_date"> From Date *</label>
                                        <input type="date" class="form-control" id="from_date" :min="fiscal_year_start_date" :max="search_terms.to_date" v-model="search_terms.from_date" @change="onkeyPress('from_date')">
                                        <div class="invalid-feedback" v-if="errors.from_date">
                                            {{errors.from_date[0]}}
                                        </div>
                                    </div>
                                </div>       

                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="to_date"> To Date *</label>
                                        <input type="date" class="form-control" id="to_date" :min="search_terms.from_date" :max="fiscal_year_end_date" v-model="search_terms.to_date" @change="onkeyPress('to_date')">
                                        <div class="invalid-feedback" v-if="errors.to_date">
                                            {{errors.to_date[0]}}
                                        </div>
                                    </div>
                                </div> 

                                
                                <div class="col-md-3">
                                    <div class="mt-3 text-right">
                                        <button type="submit" class="btn btn-primary" :disabled="disabled" @click="filterProfitLoss()">
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>Submit 
                                        </button>
                                        <a href="javascript:void(0);" style="margin-left: 5px;" class=" btn btn-primary" @click.prevent="printItem(item)" ><i class="mdi mdi-printer-outline me-1"></i> </a> 

                                        <a href="javascript:void(0);" style="margin-left: 5px;" class="btn btn-primary"
                                        @click.prevent="downloading ? null : exportToExcel()">
                                            <span v-show="downloading"  >
                                                <i class="fas fa-spinner fa-spin"></i>
                                            </span> 
                                            <i class="mdi mdi-file-excel me-1"></i> 
                                        </a>
                                    </div>
                                </div>
                                
                                
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-3 mt-3 float-right">
                                        <div class="form-check form-check-inline">
                                            <input type="checkbox" class="form-check-input" id="show_with_opening"  v-model="show_with_opening" @change="showWithOpening">
                                            <label class="form-check-label" for="show_with_opening">Show with Opening </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-3 mt-3 float-right">
                                        <div class="form-check form-check-inline">
                                            <input type="checkbox" class="form-check-input" id="show_code"  v-model="show_with_code" @change="showLedgerCode">
                                            <label class="form-check-label" for="show_code">Show with code </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-3 mt-3 float-right">
                                        <div class="form-check form-check-inline">
                                            <input type="checkbox" class="form-check-input" id="show_zero"  v-model="show_zero_balance_ledger" @change="showZeroBalanceLedger">
                                            <label class="form-check-label" for="show_zero">Show Zero Balance Ledger </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mb-3 mt-3 float-right">
                                        <div class="form-check form-check-inline">
                                            <input type="checkbox" class="form-check-input" id="show_all" v-model="show_all_profit_centers" @change="showAllIncomeStatements()">
                                            <label class="form-check-label" for="show_all">Show All Income Statements </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="card"> 
                        <div class="card-body"> 
                            <div class="income-statement" v-if="!loading">
                                <div class="row multi-statement" v-if="show_all_profit_centers && Object.keys(multiple_income_statements).length > 0">
                                    <div class="col-12">
                                        <div class="horizontal-scroll" style="overflow-x: auto; white-space: nowrap;">
                                            <div class="d-inline-block" style="min-width: 500px; margin-right: 20px;" v-for="(statement, center_name) in multiple_income_statements" :key="center_name">
                                                <h4>{{ center_name }}</h4>
                                                <table class="table table-nowrap w-100"> 
                                                    <tbody style="border-bottom: 0;">
                                                        <tr>
                                                            <td style="padding: 0; border-bottom: 0; width: 100%;">
                                                                <!-- Income -->
                                                                <table class="table table-bordered w-100" style="margin-bottom: 0;">
                                                                    <thead class="table-light">
                                                                        <tr class="success item-head">
                                                                            <th style="width: 70%; text-align: center">Particular</th>
                                                                            <th style="width: 30%; text-align: center">Amount</th>
                                                                        </tr>
                                                                        <tr class="success item-head">
                                                                            <th colspan="2" style="text-align: left">Incomes</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <AccountProfitLoss v-for="(item, i) in statement.income_accounts" :key="i" :account="item" :level="1" :spaces="5" :code_active="codeActive" :zero_active="zeroActive"></AccountProfitLoss>
                                                                </table>

                                                                <!-- Expenses -->
                                                                <table class="table table-bordered w-100" style="margin-bottom: 0;">
                                                                    <thead class="table-light">
                                                                        <tr class="success item-head">
                                                                            <th style="width: 70%; text-align: center"></th>
                                                                            <th style="width: 30%; text-align: center"></th>
                                                                        </tr>
                                                                        <tr class="success item-head">
                                                                            <th colspan="2" style="text-align: left">Expenses</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <AccountProfitLoss v-for="(item, i) in statement.expense_accounts" :key="i" :account="item" :level="1" :spaces="5" :code_active="codeActive" :zero_active="zeroActive"></AccountProfitLoss>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div class="row" v-else>
                                    <!-- Expenses -->
                                    <div class="col-md-12">
                                        <table class="table table-nowrap w-100"> 
                                            <tbody style="border-bottom: 0;">
                                                <tr>
                                                    <td style="padding: 0; border-bottom: 0; width: 100%;">
                                                        <!-- Income -->
                                                        <table class="table table-bordered w-100" style="margin-bottom: 0;">
                                                            <thead class="table-light">
                                                                <tr class="success item-head">
                                                                    <th width="70%" style="text-align: center">Particular</th>
                                                                    <th width="30%" style="text-align: center">Amount</th>
                                                                </tr>
                                                                <tr class="success item-head">
                                                                    <th colspan="2" style="text-align: left">Incomes</th>
                                                                </tr>
                                                            </thead>
                                                            <AccountProfitLoss v-for="(item, i) in income_items" :key="i" :account="item" :level="1" :spaces="5" :code_active="codeActive" :zero_active="zeroActive"></AccountProfitLoss>
                                                            <!-- <tbody>
                                                                <tr>
                                                                    <th width="70%" style="text-align: left; text-transform: uppercase;">Total Sales</th>
                                                                    <th width="30%" style="text-align: right;">{{ income_balance }}</th>
                                                                </tr>
                                                            </tbody> -->
                                                        </table>

                                                        <!-- Expenses -->
                                                        <table class="table table-bordered w-100" style="margin-bottom: 0;">
                                                            <thead class="table-light">
                                                                <tr class="success item-head">
                                                                    <th colspan="2" style="text-align: left">Expenses</th>
                                                                </tr>
                                                            </thead>
                                                            <AccountProfitLoss v-for="(item, i) in expense_items" :key="i" :account="item" :level="1" :spaces="5" :code_active="codeActive" :zero_active="zeroActive"></AccountProfitLoss>
                                                            <!-- <tbody class="w-100">
                                                                <tr>
                                                                    <th width="70%" style="text-align: left; text-transform: uppercase;">Total Expense</th>
                                                                    <th width="30%" style="text-align: right;">{{ expense_balance }}</th>
                                                                </tr>
                                                            </tbody> -->
                                                        </table>

                                                    </td>
                                                </tr>
                                                
                                            </tbody>

                                            <!-- <tbody>
                                                <tr> 
                                                    <td>
                                                        <table class="w-100">
                                                            <tr>
                                                                <th width="70%" style="text-align: left; text-transform: uppercase;">INCOME/LOSS</th>
                                                                <th width="30%" style="text-align: right;">{{ parseFloat(Number(income_balance) - Number(expense_balance * -1)).toFixed(2) }}</th>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody> -->

                                        </table>
                                    </div>
                                </div> 
                            </div>

                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div>

                        </div> 
                    </div>

                    <Modal @close="toggleModal()"  >
                        <div class="modal-content scrollbar-width-thin orderPreview" >
                            <div class="modal-header"> 
                                <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
                                <h3 style="width: 100%">Income Statement</h3>
                            </div>
                            <div class="modal-body " id="printArea" >
                                <div class="table-responsive product_table">
                                    <table class="table po_invoice">
                                        <tr>
                                            <td colspan="2" class="text-center" style="position: relative;">
                                                <h5 class="text-uppercase">{{ this.retailShopName }}</h5>
                                                <p>{{ this.retailShopAddress }} </p>
                                                <p>Dhaka, Bangladesh</p> 
                                                <h4 style="text-align: center;">Income Statement</h4> 
                                                <h4 style="text-align: center;"> {{ (from_date) ? 'From '+ from_date : '' }} {{ (to_date) ? ' To '+ to_date : '' }}</h4>
                                            </td>
                                        </tr>
                                    </table> 
                                    <table class="table table-nowrap w-100" v-if="!loading"> 
                                        <tbody style="border-bottom: 0;">
                                            <tr>
                                                <td style="padding: 0; border-bottom: 0; width: 100%;">

                                                    <!-- Incomes -->
                                                    <table class="table table-bordered w-100" style="margin-bottom: 0;">
                                                        <thead class="table-light">
                                                            <tr class="success item-head">
                                                                <th colspan="2" style="text-align: left">Incomes</th>
                                                            </tr>
                                                        </thead>
                                                        <AccountProfitLoss v-for="(item, i) in income_items" :key="i" :account="item" :level="1" :spaces="5" :code_active="codeActive" :zero_active="zeroActive"></AccountProfitLoss>
                                                        <!-- <tbody>
                                                            <tr>
                                                                <th width="70%" style="text-align: left; text-transform: uppercase;">Total Income</th>
                                                                <th width="30%" style="text-align: right;">{{ income_balance }}</th>
                                                            </tr>
                                                        </tbody> -->
                                                    </table>

                                                    <!-- Expense -->
                                                    <table class="table table-bordered w-100" style="margin-bottom: 0;">
                                                        <thead class="table-light">
                                                            <tr class="success item-head">
                                                                <th width="70%" style="text-align: center">Particular</th>
                                                                <th width="30%" style="text-align: center">Amount</th>
                                                            </tr>
                                                            <tr class="success item-head">
                                                                <th colspan="2" style="text-align: left">Expense</th>
                                                            </tr>
                                                        </thead>
                                                        <AccountProfitLoss v-for="(item, i) in expense_items" :key="i" :account="item" :level="1" :spaces="5" :code_active="codeActive" :zero_active="zeroActive"></AccountProfitLoss>
                                                        <!-- <tbody class="w-100">
                                                            <tr>
                                                                <th width="70%" style="text-align: left; text-transform: uppercase;">Total Expense</th>
                                                                <th width="30%" style="text-align: right;">{{ expense_balance }}</th>
                                                            </tr>
                                                        </tbody> -->
                                                    </table>

                                                </td>
                                            </tr>
                                            
                                        </tbody>

                                        <!-- <tbody>
                                            <tr> 
                                                <td>
                                                    <table class="w-100">
                                                        <tr>
                                                            <th width="70%" style="text-align: left;">INCOME/LOSS</th>
                                                            <th width="30%" style="text-align: right;">{{ parseFloat(Number(income_balance) - Number(expense_balance)).toFixed(2) }}</th>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>  -->
                                    </table>  
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>   

        </div>
    </transition>
</template>
<script>
import Modal from "./../helper/Modal";
import { ref, onMounted } from "vue";
import axios from 'axios';
import Form from 'vform';

import AccountProfitLoss from "@/components/AccountProfitLossV2";

export default {
    name: 'PosLeftbar',
    components: {
        Modal,
        AccountProfitLoss
    },
    data() {
        return {
            loading: true,
            downloading: false,
            isSubmit: false,
            disabled: false,
            showModal: false,
            modalActive:false,
            errors: {},
            companies: [],
            company_options: [],
            profit_centers: [],
            profit_center_options: [],
            cost_centers: [],
            cost_center_options: [],
            fiscal_years: [],
            fiscal_year_options: [],
            fiscal_year_start_date: '',
            fiscal_year_end_date: '',
            expense_items: [],
            income_items: [],
            expense_balance: 0,
            income_balance: 0,
            search_terms: new Form({
                company_id: '',
                profit_center_id: '',
                cost_center_id: '',
                fiscal_year_id: '',
                from_date: '',
                to_date: '',
            }),
            opening_balance: 0,
            from_date: '',
            to_date: '',
            show_with_opening: false,
            show_with_code: false,
            show_zero_balance_ledger: false,
            show_all_profit_centers: false,
            multiple_income_statements: [],
            codeActive: false,
            zeroActive: false,
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },
        };
    },
    created() {
        this.fetchCompany();
        this.fetchProfitCenters();
        this.fetchFiscalYear();
    },
    methods: { 

        toggleModal: function() {
            this.modalActive = !this.modalActive;  
            this.errors = '';
            this.isSubmit = false;
        },

        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data;
                this.company_options = [{label: "Select Company", value: ""}];
                res.data.data.map((item) => {
                    this.company_options.push({label: item.name, value: item.id});
                });
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

        fetchProfitCenters() { 
            axios.get(this.apiUrl+'/profit_centers/list', this.headerjson)
            .then((res) => {
                this.profit_centers = res.data.data;
                this.profit_center_options = res.data.data.map((item) => {
                    return {label: item.name, value: item.id};
                });
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            }); 
        },

        changeProfitCenter(value) {
            var profit_center_id = value;
            this.fetchCostCenters(profit_center_id);
        },

        fetchCostCenters(profit_center_id='') { 
            this.cost_center_options = [];
            this.search_terms.cost_center_id = null;
            axios.get(this.apiUrl+'/cost_centers', this.headerjson)
            .then((res) => {
                this.cost_centers = res.data.cost_centers;
                if(profit_center_id) {
                    this.cost_center_options = res.data.data.cost_centers.filter((item) => item.profit_center_id == profit_center_id).map((item) => {
                        return {label: item.center_name, value: item.id};
                    });
                }else{      
                    this.cost_center_options = []
                }
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            }); 
        },

        
        changeCompany(value) {
            var company_id = value;
            this.search_terms.comapny_id = value;
            this.fetchActiveFiscalYear(company_id);
        },

        fetchActiveFiscalYear(comapny_id='') {
            this.search_terms.fiscal_year_id = null; 
            this.search_terms.from_date = '';
            this.search_terms.to_date = '';
            this.fiscal_year_start_date = '';
            this.fiscal_year_end_date = '';

            if(comapny_id == '') {
                return false;
            }
            let formData = new Form({
                company_id: comapny_id,
            });
            this.search_terms.fiscal_year_id = null; 
            axios.post(this.apiUrl+'/fiscal_years/getActiveFiscalYear', formData, this.headerjson) 
            .then((resp) => {
                let fiscal_year = resp.data.data;
                if(fiscal_year) {
                    this.search_terms.fiscal_year_id = fiscal_year.id;
                    this.search_terms.from_date = fiscal_year.start_date;
                    this.search_terms.to_date = fiscal_year.end_date;
                    this.fiscal_year_start_date = fiscal_year.start_date;
                    this.fiscal_year_end_date = fiscal_year.end_date;
                }else{
                    this.search_terms.fiscal_year_id = '';
                    this.search_terms.from_date = '';
                    this.search_terms.to_date = '';
                    this.fiscal_year_start_date = '';
                    this.fiscal_year_end_date = '';
                }
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            });
        },

        fetchFiscalYear() {
            axios.get(this.apiUrl+'/fiscal_years', this.headerjson) 
            .then((resp) => {
                this.fiscal_years = resp.data.data;        
                this.fiscal_year_options = resp.data.data.map((item) => {
                    return {label: item.label, value: item.id};
                });
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            });
        },

        filterProfitLoss() {
            this.errors = {};
            this.isSubmit = true;
            this.disabled = true;
            if(this.search_terms.company_id == '') {
                this.errors.company_id = ['Company is required'];
            }else if(this.search_terms.fiscal_year_id == '') {
                this.errors.fiscal_year_id = ['Fiscal Year is required'];
            }else if(this.search_terms.as_on_date == '') {
                this.errors.as_on_date = ['As On Date is required'];
            }else {
                this.errors = {};
            }
            if(Object.keys(this.errors).length > 0) {
                this.disabled = false;
                this.isSubmit = false;
                return false;
            }else{
                this.disabled = true;
                this.isSubmit = true;
            }
            this.fetchProfitLoss(this.search_terms);
        },

        showWithOpening() {
            // if(this.search_terms.comapny_id == "" || this.search_terms.comapny_id == null) {
            //     this.$toast.warning("Please Select Company!");
            //     return;
            // }
            this.fetchProfitLoss(this.search_terms);
        },

        showAllIncomeStatements() {
            console.log("test-multi==", this.show_all_profit_centers);
            this.fetchProfitLoss(this.search_terms);
        },

        fetchProfitLoss(request_data='') { 
            if(this.search_terms.comapny_id == "" || this.search_terms.comapny_id == null) {
                this.$toast.warning("Please Select Company!");
                return;
            }
            this.loading = true;
            let request_variable = {
                company_id: request_data.company_id,
                profit_center_id: request_data.profit_center_id,
                cost_center_id: request_data.cost_center_id,
                fiscal_year_id: request_data.fiscal_year_id,
                from: request_data.from_date,
                to: request_data.to_date,
                show_with_opening: this.show_with_opening,
            };
            let queryParams = Object.keys(request_variable)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(request_variable[key])}`)
                .join('&');

            // let getEvent = axios.get(`${this.apiUrl}/reports/profit-loss?${queryParams}`, this.headerjson);
            let getEvent = '';
            if(this.show_all_profit_centers) {
                getEvent = axios.get(`${this.apiUrl}/reports/profit-loss-new-multiple?${queryParams}`, this.headerjson);
            }else{
                getEvent = axios.get(`${this.apiUrl}/reports/profit-loss-new?${queryParams}`, this.headerjson);
            }
            
            getEvent.then((res) => {
                if(this.show_all_profit_centers) {
                    console.log("multiple --- statement");
                    console.log("statement-- data", Object.keys(res.data.data.multi_income_statements).length);
                    this.multiple_income_statements = res.data.data.multi_income_statements;
                    this.from_date  = res.data.data.from_date;
                    this.to_date  = res.data.data.to_date;
                    this.expense_items = [];
                    this.income_items = [];
                    this.expense_balance = [];
                    this.income_balance = [];
                }else {
                    console.log("single --- statement");
                    this.expense_items = res.data.data.expense_accounts;
                    this.income_items = res.data.data.income_accounts;
                    this.expense_balance = res.data.data.expense_balance;
                    this.income_balance = res.data.data.income_balance;
                    this.from_date  = res.data.data.from_date;
                    this.to_date  = res.data.data.to_date;
                    this.multiple_income_statements = [];
                }
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
                this.isSubmit = false;
                this.disabled = false;
            });
        },
        
        checkRequiredPrimary()
        {
            if(this.search_terms.from_date && this.search_terms.to_date) {
                this.disabled = false;
            }else{
                this.disabled = true;
            }
        },
        onkeyPress: function(field) { 
            this.checkRequiredPrimary();
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },


        showLedgerCode: function(event) {
            var checked_val = this.show_with_code;
            if(checked_val) {
                this.codeActive = true;
            }else{
                this.codeActive = false;
            }
        },

        showZeroBalanceLedger: function(event) {
            var checked_val = this.show_zero_balance_ledger;
            if(checked_val) {
                this.zeroActive = true;
            }else{
                this.zeroActive = false;
            }
        },
        printItem: function () {   
            this.printContent('printArea');
        }, 

        printContent(document_id) { 
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    this.baseUrlPrintCSS+'/assets/css/print.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },

        // Export Income Statement 
        async exportToExcel() {
            let searchQuery = {
                'company_id': this.search_terms.company_id,
                'profit_center_id': this.search_terms.profit_center_id,
                'cost_center_id': this.search_terms.cost_center_id,
                'fiscal_year_id': this.search_terms.fiscal_year_id,
                'from': this.search_terms.from_date,
                'to': this.search_terms.to_date,
                'show_code': this.show_with_code,
                'show_zero_balance': this.show_zero_balance_ledger
            }
            const queryString = this.objectToQueryString(searchQuery); 

            this.downloading = true; 

            const query = queryString;
            try {
                // const response = await axios.get(`${this.apiUrl}/reports/income-statement-export${query}`, {
                const response = await axios.get(`${this.apiUrl}/reports/income-statement-export-new${query}`, {
                responseType: 'blob', // Important: set the response type to 'blob'
                headers: {
                    'Authorization' : this.$store.getters.token ? `Bearer ${this.$store.getters.token}` : "",
                    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // Specify the expected content type
                }
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'income-statement.xlsx');
                document.body.appendChild(link);
                link.click();
                this.downloading = false;
            } catch (error) { 
                this.downloading = false;
            }
        },

        objectToQueryString: function (obj) {   
            const queryString = Object.keys(obj)
                .filter((key) => obj[key] !== undefined) // Exclude undefined values
                .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
                .join('&');
            return `?${queryString}`;
        }, 


    },

    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 90%;
    display: block;
    margin: 0 auto;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

.actions a{
    margin-right: 5px;
}
</style>